export const RESET_OBSERVATIONS = 'RESET_OBSERVATIONS'
export const OBSERVATION_LIST_SET_ERROR = 'OBSERVATION_LIST_SET_ERROR'
export const OBSERVATION_LIST_RESET_ERROR = 'OBSERVATION_LIST_RESET_ERROR'
export const OBSERVATION_LIST_SET_RETRIEVED = 'OBSERVATION_LIST_SET_RETRIEVED'
export const OBSERVATION_LIST_SET_VIOLATIONS = 'OBSERVATION_LIST_SET_VIOLATIONS'
export const OBSERVATION_LIST_LOADING_TOGGLE = 'OBSERVATION_LIST_LOADING_TOGGLE'

export const OBSERVATIONS_ALL_LIST_SET_RETRIEVED = 'OBSERVATIONS_ALL_LIST_SET_RETRIEVED'
export const OBSERVATIONS_ALL_LIST_LOADING_TOGGLE = 'OBSERVATIONS_ALL_LIST_LOADING_TOGGLE'
